import { render, staticRenderFns } from "./PT090InformationParts.vue?vue&type=template&id=e53432ea&"
import script from "./PT090InformationParts.vue?vue&type=script&lang=js&"
export * from "./PT090InformationParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports